"use strict";

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _regenerator2.default.mark(function _callee(evolve, done) {
  var pop;
  return _regenerator2.default.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          done = done || function (_) {};
          pop = evolve();
          _context.next = 4;
          return pop;

        case 4:
          if (done(pop)) {
            _context.next = 10;
            break;
          }

          pop = evolve(pop);
          _context.next = 8;
          return pop;

        case 8:
          _context.next = 4;
          break;

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, this);
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/evolutionary/generator.js
 ** module id = 227
 ** module chunks = 0
 **/